<template>
  <div>
    <el-dialog
      v-if="show"
      title=""
      :visible.sync="show"
      width="48%"
      :before-close="handleClose"
      v-loading="dialogLoading"
      :close-on-click-modal="false"
    >
      <avue-crud
        ref="crud"
        :data="tableData"
        :option="option"
        :table-loading="showLoading"
        :page.sync="page"
        @on-load="onLoad"
        @selection-change="selectionChange"
        :reserveSelection="selectedRowKeys"
      >
        <template #header>
          <div>
            <div class="flex flex-wrap align-items marginBottom20">
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10">设备ID : </span>
                <div class="width200">
                  <el-input
                    v-model="searchData.deviceId"
                    placeholder="请输入"
                    clearable
                    maxlength="50"
                  ></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10">设备名称 : </span>
                <div class="width200">
                  <el-input
                    v-model="searchData.name"
                    placeholder="请输入"
                    clearable
                    maxlength="50"
                  ></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10">所属用户/ID : </span>
                <div class="width200">
                  <el-input
                    v-model="searchData.userId"
                    placeholder="请输入所属用户/ID"
                    clearable
                    maxlength="50"
                  ></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10">手机号码 : </span>
                <div class="width200">
                  <el-input
                    v-model="searchData.phone"
                    placeholder="请输入"
                    clearable
                    maxlength="50"
                  ></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10">所属分组/ID : </span>
                <div class="width200">
                  <el-input
                    v-model="searchData.groupId"
                    placeholder="请输入分组名称/ID"
                    clearable
                    maxlength="50"
                  ></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10">所属网关/ID : </span>
                <div class="width200">
                  <el-input
                    v-model="searchData.gatewayId"
                    placeholder="请输入网关名称/ID"
                    clearable
                    maxlength="50"
                  ></el-input>
                </div>
              </div>
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10">绑定时间 : </span>
                <div class="width300">
                  <el-date-picker
                    v-model="searchData.createTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="起始时间"
                    end-placeholder="结束时间"
                    :clearable="true"
                  >
                    <!-- @change="handleSearch" -->
                  </el-date-picker>
                </div>
              </div>
              <el-button
                size="medium"
                type="primary"
                @click="handleSearch"
                style="margin-bottom: 10px"
                class="marginLeft10"
                >搜索</el-button
              >
              <el-button
                size="medium"
                type="info"
                @click="handleReset"
                class="marginLeft10"
                style="margin-bottom: 10px"
                >重置</el-button
              >
            </div>
          </div>
        </template>
        <template slot="productCategory" slot-scope="{ row }">
          <div>
            {{ row.productCategory }}
          </div>
        </template>
        <template slot="hardwareVersion" slot-scope="{ row }">
          <div>
            {{ row.hardwareVersion }}
          </div>
        </template>
        <template slot="softwareVersion" slot-scope="{ row }">
          <div>
            {{ row.softwareVersion }}
          </div>
        </template>
      </avue-crud>
      <div style="text-align: center; margin-top: 30px">
        <el-button class="marginLeft10" type="" @click="$emit('closeTable')"
          >取消</el-button
        >
        <el-button class="marginLeft10" type="primary" @click="handSelected"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { upgradeDeviceList } from "@/api/upgrade/firmware";
import dayjs from "dayjs";
import {
  EUpgradeMethod,
  MUpgradeMethod,
  OUpgradeMethod,
  EUpgradeScope,
  MUpgradeScope,
  OUpgradeScope,
} from "@/enums/beCurrent/EBeCurrent";

export default {
  name: "index",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectKey: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      EUpgradeMethod: EUpgradeMethod,
      MUpgradeMethod: MUpgradeMethod,
      OUpgradeMethod: OUpgradeMethod,
      EUpgradeScope: EUpgradeScope,
      MUpgradeScope: MUpgradeScope,
      OUpgradeScope: OUpgradeScope,
      searchData: {},
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      option: {
        rowKey: "id",
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu: false,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: true,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        column: [
          {
            label: "设备ID",
            prop: "deviceId",
          },
          {
            label: "设备名称",
            prop: "name",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
          {
            label: "所属网关",
            prop: "gatewayName",
          },
          {
            label: "绑定时间",
            prop: "bindTime",
          },
        ],
      },
      selectedRowKeys: [], //表格勾选中的数据
      dialogLoading: false,
    };
  },
  // watch: {
  //   show(value) {
  //     this.onLoad();
  //   },
  // },
  created() {},
  methods: {
    toggleSelection(val) {
      this.$refs.crud.toggleSelection(val);
    },
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.bindTimeStart = dayjs(this.searchData.createTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        searchData.bindTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      upgradeDeviceList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
          this.toggleSelection();
          if (this.show) {
            this.selectedRowKeys = this.selectKey;
            this.toggleSelection(this.selectedRowKeys);
          }
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {};
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //关闭
    handleClose() {
      this.$emit("closeTable");
    },
    //表格左侧选择的数据的
    selectionChange(list) {
      console.log(
        this.selectedRowKeys,
        "this.selectedRowKeysthis.selectedRowKeys"
      );
      this.selectedRowKeys = list;
      // console.log('选中的数据',list);
      // this.$message.success('选中的数据'+ JSON.stringify(list));
    },
    handSelected() {
      this.$emit("handSelected", this.selectedRowKeys);
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}
</style>
